import { useCallback, useEffect } from "react";
import {
  is_superuser,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
} from "./Config";
import {
  announceNewScheduledOrder,
  claimDueReminders,
  getStorage,
  loadStoredOrders,
  playScheduledAlert,
  syncScheduledOrders,
} from "./scheduledReminders";

const CHECK_INTERVAL_MS = 20 * 1000;

const remindersApply =
  is_superuser || is_franchise_admin || is_franchise_manager || is_franchise_staff;

export const useScheduledReminders = () => {
  const syncFromSnapshot = useCallback((scheduledData) => {
    if (!remindersApply) return;
    syncScheduledOrders({ storage: getStorage(), rows: scheduledData, announce: announceNewScheduledOrder, nowMs: Date.now() });
  }, []);

  useEffect(() => {
    if (!remindersApply) return undefined;
    const ring = () => {
      const storage = getStorage();
      if (claimDueReminders(storage, loadStoredOrders(storage), Date.now()).length > 0) {
        playScheduledAlert();
      }
    };
    ring();
    const timer = setInterval(ring, CHECK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return syncFromSnapshot;
};
